import {SubscriptionPlansEnum, SubscriptionImagesLimitEnum} from '../types/types'

export const getImagesLimitByPlanName = (name: string) => {
  switch (name) {
    case SubscriptionPlansEnum.STARTER_MONTHLY:
      return SubscriptionImagesLimitEnum.STARTER
    case SubscriptionPlansEnum.PREMIUM_MONTHLY:
      return SubscriptionImagesLimitEnum.PREMIUM
    case SubscriptionPlansEnum.STARTER_YEARLY:
      return SubscriptionImagesLimitEnum.STARTER
    case SubscriptionPlansEnum.PREMIUM_YEARLY:
      return SubscriptionImagesLimitEnum.PREMIUM
    case SubscriptionPlansEnum.FREE:
      return SubscriptionImagesLimitEnum.FREE
    case SubscriptionPlansEnum.APPSUMOTIER1:
      return SubscriptionImagesLimitEnum.APPSUMOTIER1
    case SubscriptionPlansEnum.APPSUMOTIER2:
      return SubscriptionImagesLimitEnum.APPSUMOTIER2
    case SubscriptionPlansEnum.APPSUMOTIER3:
      return SubscriptionImagesLimitEnum.APPSUMOTIER3
    default:
      return SubscriptionImagesLimitEnum.FREE
  }
}
